import * as React from 'react';
import { connect } from 'react-redux';
import { Button, Card, CardBody, CardHeader, Col, Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row } from 'reactstrap';
import { ApplicationState } from '../../store';
import * as SessionMdl from '../../models/SessionModel';
import { ServiceMaster } from '../../models/ServiceMasterModel';
import * as SessionStore from '../../store/Session';
import * as BillToStore from '../../store/BillTo';
import { useHistory } from 'react-router-dom';
import { SaPhone } from '../Misc/SawinComponents';
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


type MyProps =
    { SMList: ServiceMaster[] } & { SessionState: SessionMdl.SessionModel } & typeof SessionStore.actionCreators;

const SMPicker: React.FunctionComponent<MyProps> = (props: MyProps) => {

    if (props.SMList && props.SMList.length > 0) {
        return (
            <Container fluid={true}>
                {props.SMList.map((item, index) =>
                    <Row key={index}>
                        <Col>
                            <SMPickerCard item={item} myAction={props.setSelectedSM} />
                        </Col>
                    </Row>
                )}
            </Container>
        );
    } else {
        return (
            <Container fluid={true}>
                <h3>No locations found</h3>
            </Container>
        );
    }
}

function mapStateToProps(state: ApplicationState) {
      
    return {
        ...{ SMList: BillToStore.selectors.getServiceMasterFromSelectedAR(state) },
        ...{ SessionState: state.sessionState } 
    }
}

export default connect(
    (state: ApplicationState) => (mapStateToProps(state)), SessionStore.actionCreators)(SMPicker as any);

type SMPickerCardProps =
    { item: ServiceMaster, myAction: Function };

const SMPickerCard: React.FunctionComponent<SMPickerCardProps> = (props: SMPickerCardProps) => {

    const history = useHistory();
    
    const handleClick = (arNum: string) => {
        props.myAction(arNum);
        history.push('/');
    }


    return (<div><Card className='ARPicker-card'>
        <CardHeader>
          <b>  {props.item.id}-{props.item.name.displayName} </b>
        </CardHeader>
        <CardBody>

            <Row>
                <Col>
                    {props.item.address.line1}
                </Col>
            </Row>
            <Row>
                <Col>
                    {`${props.item.address.city}, ${props.item.address.state} ${props.item.address.zip}`}
                </Col>
            </Row>  
            <Row>
                <Col>
                    <br />
                    <FontAwesomeIcon icon={faPhoneAlt} /> {' '}
                    <SaPhone UnformattedPhone={props.item.phone.displayPhone} />
                </Col>
                <Col className="right-align">
                    <Button onClick={() => { handleClick(props.item.id) }}>Select</Button>
                </Col>
            </Row>
        </CardBody>
    </Card></div>);
   
}